// ============================================================
// EDITABLE CONTENT LAYER — Ansar Public School Mundeke
// ------------------------------------------------------------
// The school can update every value in this file without
// touching page or component code. Values wrapped like
// [INSERT VERIFIED ...] are placeholders — replace them with
// verified information before going live. Nothing here is
// presented as fact unless the school confirms it.
// ============================================================

export const site = {
  name: "Ansar Public School Mundeke",
  shortName: "Ansar Public School",
  areaLabel: "Mundeke Goraya · Daska · Sialkot",

  // Verified public phone
  phoneDisplay: "+92 345 6232508",
  phoneHref: "tel:+923456232508",

  // WhatsApp is independently editable — update the two lines below only
  whatsappDisplay: "+92 345 6232508",
  whatsappHref: "https://wa.me/923456232508",

  email: "[INSERT OFFICIAL EMAIL]",

  addressLine1: "Village & Post Office Mundeke Goraya",
  addressLine2: "Tehsil Daska, District Sialkot",
  addressLine3: "Punjab, Pakistan",

  openingHours: "[INSERT VERIFIED SCHOOL TIMINGS]",
  classes: "[INSERT VERIFIED CLASSES]",
  curriculum: "[INSERT VERIFIED CURRICULUM]",
  board: "[INSERT VERIFIED BOARD/AFFILIATION]",
  subjects: "[INSERT VERIFIED SUBJECTS]",
  admissionDates: "[INSERT VERIFIED ADMISSION DATES]",
  fees: "[INSERT VERIFIED FEE STRUCTURE]",
  facilities: "[INSERT VERIFIED FACILITIES]",
  academicYear: "[INSERT VERIFIED ACADEMIC YEAR]",
  schoolHistory: "[INSERT VERIFIED SCHOOL HISTORY]",
  mission: "[INSERT VERIFIED MISSION]",
  vision: "[INSERT VERIFIED VISION]",
  leadership: "[INSERT VERIFIED LEADERSHIP INFORMATION]",
  documents: "[INSERT VERIFIED DOCUMENT REQUIREMENTS]",

  announcement: "Admissions Open — [INSERT VERIFIED ACADEMIC YEAR]",

  mapEmbedUrl:
    "https://www.google.com/maps?q=Mundeke%20Goraya%2C%20Daska%2C%20Sialkot%2C%20Punjab%2C%20Pakistan&output=embed",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Mundeke%20Goraya%2C%20Daska%2C%20Sialkot%2C%20Punjab%2C%20Pakistan",
  googleReviewUrl: "[INSERT GOOGLE REVIEW LINK]",

  // Add verified social links only, e.g. { label: "Facebook", href: "https://..." }
  socialLinks: [],
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Academics", to: "/academics" },
  { label: "Admissions", to: "/admissions" },
  { label: "Gallery", to: "/gallery" },
  { label: "Reviews", to: "/reviews" },
  { label: "FAQs", to: "/faqs" },
  { label: "Contact", to: "/contact" },
];

const u = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

// Stock placeholders — replace with real school photos when supplied.
export const images = {
  hero: u("photo-1509062522246-3755977927d7", 1600),
  about: u("photo-1427504494785-3a9ca7044f45", 1200),
  environment: u("photo-1580582932707-520aed937b7b", 1200),
  books: u("photo-1497633762265-9d179a990aa6", 1200),
  teacherBoard: u("photo-1546410531-bb4caa6b424d", 1200),
  kidWriting: u("photo-1588072432836-e10032774350", 1200),
  kidsStudy: u("photo-1596464716127-f2a82984de30", 1200),
  campus: u("photo-1541339907198-e08756dedf3f", 1200),
  learningFlat: u("photo-1503676260728-1c00da094a0b", 1200),
  schoolChildren: u("photo-1569173675610-42c361a86e37", 1200),
  teacherStudent: u("photo-1511629091441-ee46146481b6", 1200),
  studentsUniform:
    "https://images.pexels.com/photos/37898351/pexels-photo-37898351.jpeg?auto=compress&cs=tinysrgb&w=1200",
  classroomLearning:
    "https://images.pexels.com/photos/9159042/pexels-photo-9159042.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

// Placeholder program cards — grades are NOT confirmed until verified.
export const programs = [
  { id: "early-years", title: "Early Years", text: "[INSERT VERIFIED PROGRAM INFORMATION]" },
  { id: "primary", title: "Primary Education", text: "[INSERT VERIFIED PROGRAM INFORMATION]" },
  { id: "middle", title: "Middle School", text: "[INSERT VERIFIED PROGRAM INFORMATION]" },
  { id: "secondary", title: "Secondary Education", text: "[INSERT VERIFIED PROGRAM INFORMATION]" },
];

export const trustItems = [
  { icon: "GraduationCap", label: "Educational Institution" },
  { icon: "MapPin", label: "Mundeke Goraya, Daska" },
  { icon: "PhoneCall", label: "Direct Admission Enquiries" },
  { icon: "Users", label: "Local Community School" },
];

export const whyChooseUs = [
  {
    icon: "MapPin",
    title: "Local & Accessible",
    text: "Located in Mundeke Goraya, the school serves families across the surrounding Daska and Sialkot communities.",
  },
  {
    icon: "HeartHandshake",
    title: "Supportive Learning",
    text: "A caring classroom environment where every student is encouraged to ask questions and grow in confidence.",
  },
  {
    icon: "School",
    title: "Welcoming Environment",
    text: "A friendly campus where students and parents feel at home from their very first visit.",
  },
  {
    icon: "MessagesSquare",
    title: "Parent Communication",
    text: "Parents can reach the school team directly by phone, WhatsApp or a campus visit — no barriers, no runaround.",
  },
];

// Placeholder review cards — never presented as real reviews.
export const reviews = [
  {
    name: "[INSERT VERIFIED REVIEWER NAME]",
    rating: 5,
    text: "[INSERT VERIFIED GOOGLE REVIEW]",
    date: "[INSERT REVIEW DATE]",
    link: "[INSERT GOOGLE REVIEW LINK]",
  },
  {
    name: "[INSERT VERIFIED REVIEWER NAME]",
    rating: 5,
    text: "[INSERT VERIFIED GOOGLE REVIEW]",
    date: "[INSERT REVIEW DATE]",
    link: "[INSERT GOOGLE REVIEW LINK]",
  },
  {
    name: "[INSERT VERIFIED REVIEWER NAME]",
    rating: 5,
    text: "[INSERT VERIFIED GOOGLE REVIEW]",
    date: "[INSERT REVIEW DATE]",
    link: "[INSERT GOOGLE REVIEW LINK]",
  },
];

export const homeFaqs = [
  {
    q: "What classes does Ansar Public School offer?",
    a: "[INSERT VERIFIED CLASSES]",
    note: "Please contact the school office to confirm the classes currently offered.",
  },
  {
    q: "How can I apply for admission?",
    a: "Start with an admission enquiry — call the school, send a WhatsApp message, or submit the enquiry form on this website. The school team will confirm available classes and guide you through the next steps.",
  },
  {
    q: "Where is the school located?",
    a: "Ansar Public School is located at Village & Post Office Mundeke Goraya, Tehsil Daska, District Sialkot, Punjab, Pakistan.",
  },
  {
    q: "What are the school timings?",
    a: "[INSERT VERIFIED SCHOOL TIMINGS]",
    note: "Contact the school office to confirm current timings.",
  },
  {
    q: "Which curriculum or board does the school follow?",
    a: "[INSERT VERIFIED BOARD/AFFILIATION]",
    note: "Please confirm the curriculum and affiliation directly with the school.",
  },
  {
    q: "How can parents contact the school?",
    a: "Parents can call +92 345 6232508, send a WhatsApp message, or visit the school campus in Mundeke Goraya during school hours.",
  },
];

export const allFaqs = [
  {
    category: "Admissions & Fees",
    items: [
      {
        q: "How do I start the admission process?",
        a: "Make an enquiry by phone, WhatsApp or the online form. The school team will confirm whether a seat is available in the class you are interested in and share the admission requirements.",
      },
      { q: "Which classes are open for admission?", a: "[INSERT VERIFIED CLASSES]" },
      { q: "What are the important admission dates?", a: "[INSERT VERIFIED ADMISSION DATES]" },
      { q: "What is the fee structure?", a: "[INSERT VERIFIED FEE STRUCTURE]" },
      { q: "Which documents are required for admission?", a: "[INSERT VERIFIED DOCUMENT REQUIREMENTS]" },
    ],
  },
  {
    category: "School Information",
    items: [
      { q: "What are the school timings?", a: "[INSERT VERIFIED SCHOOL TIMINGS]" },
      { q: "Which curriculum or board does the school follow?", a: "[INSERT VERIFIED BOARD/AFFILIATION]" },
      { q: "Which subjects are taught?", a: "[INSERT VERIFIED SUBJECTS]" },
      { q: "What facilities does the campus have?", a: "[INSERT VERIFIED FACILITIES]" },
    ],
  },
  {
    category: "Location & Contact",
    items: [
      {
        q: "Where is Ansar Public School located?",
        a: "Village & Post Office Mundeke Goraya, Tehsil Daska, District Sialkot, Punjab, Pakistan. Use the Get Directions button on the Contact page for turn-by-turn navigation.",
      },
      {
        q: "How can I contact the school directly?",
        a: "Call +92 345 6232508 during school hours, send a WhatsApp message, or visit the campus. An official email address will be published once confirmed.",
      },
      {
        q: "Does the school provide transport?",
        a: "[INSERT VERIFIED ANSWER]",
      },
    ],
  },
];

export const galleryImages = [
  { src: images.campus, alt: "School campus building exterior", category: "Campus" },
  { src: images.environment, alt: "Bright empty classroom with desks and board", category: "Classrooms" },
  { src: images.hero, alt: "Teacher presenting a lesson to students in class", category: "Learning" },
  { src: images.kidWriting, alt: "Student writing notes at a desk", category: "Learning" },
  { src: images.kidsStudy, alt: "Children studying together with books", category: "Activities" },
  { src: images.teacherBoard, alt: "Teacher explaining a lesson at the whiteboard", category: "Classrooms" },
  { src: images.books, alt: "Stack of well-used school books", category: "Learning" },
  { src: images.schoolChildren, alt: "Children outside a school building", category: "Campus" },
  { src: images.teacherStudent, alt: "Teacher guiding a student one-on-one", category: "Activities" },
  { src: images.learningFlat, alt: "School supplies and learning materials", category: "Events" },
  { src: images.classroomLearning, alt: "Students engaged in a classroom activity", category: "Classrooms" },
  { src: images.studentsUniform, alt: "Students in school uniform together", category: "Events" },
];

export const admissionSteps = [
  {
    step: "01",
    title: "Make an enquiry",
    text: "Call, WhatsApp or submit the online enquiry form to express your interest.",
  },
  {
    step: "02",
    title: "Confirm available class",
    text: "The school team confirms which classes currently have seats available.",
  },
  {
    step: "03",
    title: "Receive admission requirements",
    text: "You receive the list of required documents and any next steps from the school.",
  },
  {
    step: "04",
    title: "Complete the school's admission process",
    text: "Visit the campus, submit documents and finalise the admission with the school office.",
  },
];

export const btnPrimary =
  "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full bg-brand px-6 py-3 text-[15px] font-semibold text-white shadow-sm transition-[background-color,transform] duration-200 hover:bg-brand-dark hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2";

export const btnSecondary =
  "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full border border-brand bg-white px-6 py-3 text-[15px] font-semibold text-brand transition-[background-color,transform] duration-200 hover:bg-brand-light hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2";

export const btnLight =
  "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-[15px] font-semibold text-brand transition-[background-color,transform] duration-200 hover:bg-brand-light hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand";
